import {
    SET_ADMIN_TASK_GRID_VALUES, 
    SET_ATTACHMENTS_LIST, 
    SET_INITIAL_TASK_DETAIL, 
    SET_LINKED_ATTACHMENTS,
    GET_FLEET_PROCESSING_ITEM_STATUS_LIST, 
    SET_FLEET_PROCESSING_ITEM_STATUS_LIST, 
    SET_RECEVING_COSTCENTER_OPTION,
    SET_UPDATE_REASON_CODE_RESPONSE,
    GET_ORDER_HEADER_DETAILS,
    SET_ORDER_HEADER_DETAILS,
    SET_FLEET_ITEM_HEADER_DETAILS,
    GET_FLEET_ITEM_HEADER_DETAILS,
    GET_FLEET_ITEM_DETAILS,
    SET_FLEET_ITEM_DETAILS,
    GET_FLEET_ITEM_PURCHASE_DETAILS,
    GET_FLEET_ITEM_PURCHASE_ORDER,
    SET_FLEET_ITEM_PURCHASE_DETAILS,
    SET_FLEET_ITEM_PURCHASE_ORDER,
    GET_FLEET_ITEM_VENDOR_DETAILS,
    SET_FLEET_ITEM_VENDOR_DETAILS,
    GET_FLEET_ITEM_TASK_DETAILS,
    SET_FLEET_ITEM_TASK_DETAILS,
    GET_FLEET_ITEM_PURCHASE_DETAILS_SAVE,
    SET_FLEET_ITEM_PURCHASE_DETAILS_SAVE,
    GET_FLEET_ITEM_PURCHASE_ORDER_SAVE,
    SET_FLEET_ITEM_PURCHASE_ORDER_SAVE,
    GET_FLEET_ITEM_VENDOR_DETAILS_SAVE,
    SET_FLEET_ITEM_VENDOR_DETAILS_SAVE,
    SET_COMMENT_SAVED,
    SAVE_COMMENT,
    SAVE_ITEM_DETAILS,
    SET_IS_ITEM_DETAILS_SAVED,
    SAVE_ITEM_ATTACHMENTS_LINKED,
    SET_ITEM_ATTACHMENTS_LINKED_SAVED,
    SAVE_MULTIPLE_PURCHASE_DETAILS,
    IS_MULTIPLE_POD_SAVED,
    SAVE_MULTIPLE_DEALER_VENDOR_DETAILS,
    IS_MULTIPLE_DEALER_VENDOR_SAVED,
    SAVE_MULTIPLE_PO_DETAILS,
    IS_MULTIPLE_PO_DETAILS_SAVED,
    SAVE_CONSOLIDATED_PO_FLAG,
    IS_CONSOLIDATED_FLAG_SAVED,
    SAVE_ORDER_ATTACHMENTS,
    IS_ORDER_ATTACHMENTS_SAVED,
    SAVE_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_OPEN_ACCORDION_LIST,
    VALIDATE_VIN_DUPLICATE,
    SET_VIN_VALIDATION_RESULT,
    SAVE_CATALOG_OVERRIDE,
    SET_CATALOG_OVERRIDE_SAVED
} from "./FleetManagementType"

const setAdminTaskGridValues = (adminTaskGridValues: any) => ({
    type: SET_ADMIN_TASK_GRID_VALUES,
    adminTaskGridValues
})

const setInitialTaskDetail = (initialTaskDetail: any) => ({
    type: SET_INITIAL_TASK_DETAIL,
    initialTaskDetail
})

const setAttachmentList = (attachmentList: any) => ({
    type: SET_ATTACHMENTS_LIST,
    attachmentList
})

const setLinkedAttachments = (linkedAttachments?: any) => ({
    type: SET_LINKED_ATTACHMENTS,
    linkedAttachments
})

const setRecevingCostCenterOption = (receivingCostCenterOption?: any ) => ({
    type: SET_RECEVING_COSTCENTER_OPTION,
    receivingCostCenterOption
})

const getFleetProccessingItemStatusList = () => ({
    type: GET_FLEET_PROCESSING_ITEM_STATUS_LIST
})

const setFleetProccessingItemStatusList = (itemStatusList: any) => ({
    type: SET_FLEET_PROCESSING_ITEM_STATUS_LIST,
    itemStatusList
})

const setReasonCodeResponse=(data:any)=>({
    type:SET_UPDATE_REASON_CODE_RESPONSE,
    payload:data
  })

  const getOrderHeaderDetail = (orderId: any) => {
    return {
      type: GET_ORDER_HEADER_DETAILS,
      orderId,
    };
  };
  
  const setOrderHeaderDetail = (value: any) => {
    return {
      type: SET_ORDER_HEADER_DETAILS,
      value,
    };
  };

  const getFleetItemHeaderDetail = (orderId: any) => {
    return {
      type: GET_FLEET_ITEM_HEADER_DETAILS,
      orderId,
    };
  };
  
  const setFleetItemHeaderDetail = (value: any) => {
    return {
      type: SET_FLEET_ITEM_HEADER_DETAILS,
      value,
    };
  };

  const getFleetItemDetails = (fleetId: any) => {
    return {
      type: GET_FLEET_ITEM_DETAILS,
      fleetId,
    };
  };
  
  const setFleetItemDetails = (value: any) => {
    return {
      type: SET_FLEET_ITEM_DETAILS,
      value,
    };
  };

  const getFleetItemPurchaseDetails = (fleetId: any) => {
    return {
      type: GET_FLEET_ITEM_PURCHASE_DETAILS,
      fleetId,
    };
  };
  
  const setFleetItemPurchaseDetails = (value: any) => {
    return {
      type: SET_FLEET_ITEM_PURCHASE_DETAILS,
      value,
    };
  };

  const getFleetItemPurchaseOrder = (fleetId: any) => {
    return {
      type: GET_FLEET_ITEM_PURCHASE_ORDER,
      fleetId,
    };
  };
  
  const setFleetItemPurchaseOrder = (value: any) => {
    return {
      type: SET_FLEET_ITEM_PURCHASE_ORDER,
      value,
    };
  };

const getFleetItemVendorDetails = (fleetId: any) => {
  return {
    type: GET_FLEET_ITEM_VENDOR_DETAILS,
    fleetId,
  };
};

const setFleetItemVendorDetails = (fleetItemVendorDetails: any) => {
  return {
    type: SET_FLEET_ITEM_VENDOR_DETAILS,
    fleetItemVendorDetails: fleetItemVendorDetails
  };
};

const getFleetItemTaskDetails = (fleetId: any) => {
  return {
    type: GET_FLEET_ITEM_TASK_DETAILS,
    fleetId,
  };
};

const setFleetItemTaskDetails = (fleetItemTaskDetails: any) => {
  return {
    type: SET_FLEET_ITEM_TASK_DETAILS,
    fleetItemTaskDetails: fleetItemTaskDetails,
  };
};

const getFleetItemPurchaseDetailsSave = (purchaseDetails: any) => {
  return {
    type: GET_FLEET_ITEM_PURCHASE_DETAILS_SAVE,
    purchaseDetails,
  };
};

const setFleetItemPurchaseDetailsSave = (fleetItemPurchaseDetailsSave: any) => {
  return {
    type: SET_FLEET_ITEM_PURCHASE_DETAILS_SAVE,
    fleetItemPurchaseDetailsSave: fleetItemPurchaseDetailsSave,
  };
};

const getFleetItemPurchaseOrderSave = (purchaseOrderdetails: any) => {
  return {
    type: GET_FLEET_ITEM_PURCHASE_ORDER_SAVE,
    purchaseOrderdetails,
  };
};

const setFleetItemPurchaseOrderSave = (fleetItemPurchaseOrderSave: any) => {
  return {
    type: SET_FLEET_ITEM_PURCHASE_ORDER_SAVE,
    fleetItemPurchaseOrderSave: fleetItemPurchaseOrderSave,
  };
};

const getFleetItemVendorDetailsSave = (vendorDetails: any) => {
  return {
    type: GET_FLEET_ITEM_VENDOR_DETAILS_SAVE,
    vendorDetails,
  };
};

const setFleetItemVendorDetailsSave = (fleetItemVendorDetailsSave: any) => {
  return {
    type: SET_FLEET_ITEM_VENDOR_DETAILS_SAVE,
    fleetItemVendorDetailsSave: fleetItemVendorDetailsSave
  };
};

const saveComment = (comment: any) => {
  return {
    type: SAVE_COMMENT,
    comment
  };
};

const setCommentSaved = (value: any) => {
  return {
    type: SET_COMMENT_SAVED,
    value
  };
};

const saveItemDetails = (itemDetails: any) => {
  return {
    type: SAVE_ITEM_DETAILS,
    itemDetails
  };
};

const setIsItemSaved = (value: any) => {
  return {
    type: SET_IS_ITEM_DETAILS_SAVED,
    value
  };
};

const saveItemAttachmentsLinked = (attachmentsDetails: any) => {
  return {
    type: SAVE_ITEM_ATTACHMENTS_LINKED,
    attachmentsDetails
  };
};

const setIsItemAttachmentsLinkedSaved = (value: any) => {
  return {
    type: SET_ITEM_ATTACHMENTS_LINKED_SAVED,
    value
  };
};

const saveMultiplePODetails = (purchaseDetails: any) => {
  return {
    type: SAVE_MULTIPLE_PURCHASE_DETAILS,
    purchaseDetails
  };
};

const setIsMultiplePODSaved = (value: any) => {
  return {
    type: IS_MULTIPLE_POD_SAVED,
    value
  };
};

const saveMultipleDealerVendorDetails = (dealerdetails: any) => {
  return {
    type: SAVE_MULTIPLE_DEALER_VENDOR_DETAILS,
    dealerdetails
  };
};

const setIsMultipleDealerVendorSaved = (value: any) => {
  return {
    type: IS_MULTIPLE_DEALER_VENDOR_SAVED,
    value
  };
};

const saveMultiplePurchaseOrder = (purchaseOrderdetails: any) => {
  return {
    type: SAVE_MULTIPLE_PO_DETAILS,
    purchaseOrderdetails
  };
};

const setIsMultiplePurchaseOrderSaved = (value: any) => {
  return {
    type: IS_MULTIPLE_PO_DETAILS_SAVED,
    value
  };
};

const saveConsolidatedPOFlag = (payload: any) => {
  return {
    type: SAVE_CONSOLIDATED_PO_FLAG,
    payload
  };
};

const setIsConsolidatedPOFlagSaved = (value: any) => {
  return {
    type: IS_CONSOLIDATED_FLAG_SAVED,
    value
  };
};

const saveOrderAttachments=(payload:any)=>({
  type:SAVE_ORDER_ATTACHMENTS,
  payload
})

const isOrderAttachmentSaved=(flag:any)=>({
  type:IS_ORDER_ATTACHMENTS_SAVED,
  flag
})

const saveAssignedToForAllItem = (payload: any) => {
  return {
    type: SAVE_ASSIGNED_TO_FOR_ALL_ITEM,
    payload,
  };
}

const setAssignedToForAllItem = (assignedForAllItem: any) => {
  return{
    type: SET_ASSIGNED_TO_FOR_ALL_ITEM,
    assignedForAllItem: assignedForAllItem
  }
}

const setOpenAccordionList = (list: any) => {
  return {
    type: SET_OPEN_ACCORDION_LIST,
    list
  }
}

const validateVinDuplicate = (req: any) => {
  return {
    type: VALIDATE_VIN_DUPLICATE,
    vinSerial: req.vinSerial,
    currentOrderRequestDetailId: req.currentOrderRequestDetailId,
    currentFleetRequestDetailId: req.currentFleetRequestDetailId
  }
}

const setVinValidationResult = (validationResult: any) => {
  return {
    type: SET_VIN_VALIDATION_RESULT,
    validationResult
  }
}

const saveCatalogOverride = (catalogOverrideDetails: any) => {
  return {
    type: SAVE_CATALOG_OVERRIDE,
    catalogOverrideDetails
  }
}

const setCatalogOverrideSaved = (catalogOverrideSaved: any) => {
  return {
    type: SET_CATALOG_OVERRIDE_SAVED,
    catalogOverrideSaved
  }
}

export {
    setAdminTaskGridValues,
    setInitialTaskDetail,
    setAttachmentList,
    setLinkedAttachments,
    getFleetProccessingItemStatusList,
    setFleetProccessingItemStatusList,
    setRecevingCostCenterOption,
    setReasonCodeResponse,
    getOrderHeaderDetail,
    setOrderHeaderDetail,
    getFleetItemHeaderDetail,
    setFleetItemHeaderDetail,
    getFleetItemDetails,
    setFleetItemDetails,
    getFleetItemPurchaseDetails,
    setFleetItemPurchaseDetails,
    getFleetItemPurchaseOrder,
    setFleetItemPurchaseOrder,
    getFleetItemVendorDetails,
    setFleetItemVendorDetails,
    getFleetItemTaskDetails,
    setFleetItemTaskDetails,
    getFleetItemPurchaseDetailsSave,
    setFleetItemPurchaseDetailsSave,
    getFleetItemPurchaseOrderSave,
    setFleetItemPurchaseOrderSave,
    getFleetItemVendorDetailsSave,
    setFleetItemVendorDetailsSave,
    saveComment,
    setCommentSaved,
    setIsItemSaved,
    saveItemDetails,
    saveItemAttachmentsLinked,
    setIsItemAttachmentsLinkedSaved,
    saveMultiplePODetails,
    setIsMultiplePODSaved,
    saveMultipleDealerVendorDetails,
    setIsMultipleDealerVendorSaved,
    saveMultiplePurchaseOrder,
    setIsMultiplePurchaseOrderSaved,
    saveConsolidatedPOFlag,
    setIsConsolidatedPOFlagSaved,
    saveOrderAttachments,
    isOrderAttachmentSaved,
    saveAssignedToForAllItem,
    setAssignedToForAllItem,
    setOpenAccordionList,
    validateVinDuplicate,
    setVinValidationResult,
    saveCatalogOverride,
    setCatalogOverrideSaved
}